import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View } from 'react-native';
import { comps_getCompetitionSeasonById } from '../../store/actionsv1/comps';
import { CompetitionProps, CompetitionSeasonProps } from '../../store/types/tp_svc';
import { Helmet } from 'react-helmet-async';
import { BEEventApi, BELinkApi, CompetitionManager, CompetitionModule, SeasonManager, SeasonModule } from 'be-components';
import { V1_SHOW_AUTHENTICATE } from '../../store/actionsv1/types';
import Colors from '../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';


const CompetitionSeasonScreen = ({ route, navigation }:any) => {
    const [ competition_season, setCompetitionSeason ] = useState<CompetitionSeasonProps>();
    const [ mode, setMode ] = useState('play');

    const dispatch = useDispatch();
    const player = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id);
    const player_referral = useSelector((state:any) => state.player.player_referral, (left, right) => left?.player_referral_id == right?.player_referral_id);


    useEffect(() => {
        if(!route.params.competition_season_id){ return }
        getDataFromServer(route.params.competition_season_id)
        if(route.params?.mode){ setMode(route.params.mode) }
    },[route.params?.competition_season_id])

    const getDataFromServer = async(competition_season_id:string) => {
        const comp = await comps_getCompetitionSeasonById(competition_season_id)
        if(route.params.mode){ setMode(route.params.mode) }
        setCompetitionSeason(comp)
    }

    const handleShareCompetition = async(comp:any) => {
        if(!competition_season){ return }
        const { url, generated_link } = await BELinkApi.generateShortLink({
            redirect_url: `https://app.bettoredge.com/competition/season/play/${comp.competition_season_id}?refer=${player_referral?.referral_code}`,
            generator:'player',
            link_type: 'user_generated_link',
            link_sub_type: 'competition_link'
        })
        BELinkApi.share('Join BettorEdge!', `Compete against me in the ${comp.competition_name} season long competition!`, url, generated_link.generated_link_id)
    }

    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.shade100 }}>
            {competition_season ?
            <Helmet>
                <title>{competition_season.season_name}</title>
                <meta name='description' content={competition_season.season_description} />
                <meta name='og:image' content={competition_season.image?.url} />
            </Helmet>
            :<></>}
            <SeasonModule
                competition_season_id={route.params.competition_season_id}
                player_id={player?.player_id}
                onCompetitionSelect={(c) => navigation.push('CompetitionPlay', { competition_id: c.competition_id })}
                //onClose={() => navigation.goBack()}
                //onManageCompetition={() => setMode('manage')}
                onRequestAuthenticate={() => dispatch({ type:V1_SHOW_AUTHENTICATE, show_authenticate: { visible: true, hide_close:false, nav_out:false } })}
                //onEvent={(ev) => BEEventApi.saveEvent(ev)}
                onShareSeason={handleShareCompetition}
            />
            {mode == 'manage' ?
            <View style={{ position:'absolute', top:0, left:0, right:0, bottom:0, backgroundColor:Colors.shades.white }}>
                <SeasonManager
                    competition_season_id={route.params.competition_season_id}
                    //onClose={() => setMode('play')}
                    onCompetitionSelect={(c) => navigation.push('CompetitionPlay', { competition_id: c.competition_id, mode: 'manage' })}
                    player_id={player?.player_id}
                    onCompetitionCreate={(c) => navigation.push('CompetitionPlay', { competition_id: c.competition_id, mode: 'manage' })}
                />
            </View>
            :<></>}
            {competition_season?.admin_id == player?.player_id ?
            <TouchableOpacity style={{ position:'absolute', bottom:3, right:3, borderRadius:22, backgroundColor:Colors.brand.electric , padding:10}} onPress={() => mode == 'play' ? setMode('manage') : setMode('play') }>
                <Text size={12} color={Colors.shades.white} weight='semibold'>{mode == 'play' ? 'MANAGE' : 'PLAY'}</Text>
            </TouchableOpacity>
            :<></>}
        </View>
    )
}

export default CompetitionSeasonScreen